<template>
  <b-card>
    <b-card-header class="bg-info">
      <h4 class="title">
        ایجاد نظرسنجی
      </h4>
    </b-card-header>
    <b-card-body>
      <validation-observer
        #default="handleSubmit"
        ref="refFormObserver"
      >
        <b-form @submit.stop.prevent>
          <b-row>
            <b-col cols="4">
              <validation-provider
                #default="validationContext"
                name="عنوان"
                rules="required"
              >
                <b-form-group>
                  <label for="name">
                    <feather-icon
                      icon="FeatherIcon"
                    />
                    عنوان نظرسنجی
                  </label>
                  <b-form-input
                    id="name"
                    v-model="vote.title"
                    :state="getValidationState(validationContext)"
                    trim
                    placeholder="عنوان نظرسنجی را وارد نمایید"
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="4">
              <validation-provider
                #default="validationContext"
                name="لینک"
                rules="required|url"
              >
                <b-form-group>
                  <label for="link">
                    <feather-icon
                      icon="LinkIcon"
                    />
                    لینک نظرسنجی
                  </label>
                  <b-form-input
                    id="link"
                    v-model="vote.link"
                    placeholder="لینک نظرسنجی را وارد نمایید"
                    :state="getValidationState(validationContext)"
                    trim
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>

              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4">
              <b-overlay :show="rolesList.length == 0">
                <b-form-group>
                  <label for="role">
                    <feather-icon
                      icon="UserCheckIcon"
                    />
                    نقش کاربر
                  </label>
                  <v-select
                    v-model="vote.roles"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="slug"
                    :options="rolesList"
                    :reduce="role => role.id"
                    multiple
                  />
                </b-form-group>
              </b-overlay>
            </b-col>
            <b-col cols="4">
              <b-overlay :show="permissionList.length == 0">
                <b-form-group>
                  <label for="permissions">
                    <feather-icon
                      icon="CheckSquareIcon"
                    />
                    لیست دسترسی ها
                  </label>
                  <v-select
                    v-model="vote.permissions"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    multiple
                    label="slug"
                    :options="permissionList"
                    :reduce="permission => permission.id"
                  />
                </b-form-group>
              </b-overlay>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="4"
              class="mb-2"
            >
              <b-form-checkbox
                v-model="vote.is_active"
                checked="true"
                name="check-button"
                switch
              >
                فعال
              </b-form-checkbox>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      <button
        class="btn btn-info"
        @click="createVote"
      >
        ذخیره نظرسنجی
      </button>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BOverlay,
  BInputGroup,
  BInputGroupAppend, BFormInvalidFeedback, BFormCheckbox,
} from 'bootstrap-vue'
import VSelect from 'vue-select'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import farsi from 'vee-validate/dist/locale/fa'
import formValidation from '@core/comp-functions/forms/form-validation'
import { required, url } from '@core/utils/validations/validations'

export default {
  name: 'VoteCreate',
  components: {
    BFormCheckbox,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    VSelect,
    BOverlay,
    BInputGroup,
    BInputGroupAppend,
  },
  data() {
    return {
      vote: {
        is_active: true,
      },
      rolesList: [],
      permissionList: [],
    }
  },
  created() {
    localize('fa', {
      messages: farsi.messages,
    })
  },
  mounted() {
    this.getPermissions()
    this.getRoles()
  },
  methods: {
    createVote() {
      this.$refs.refFormObserver.validate()
        .then(success => {
          if (success) {
            this.$http.post('votes', this.vote)
              .then(({ data }) => {
                if (data.status) {
                  this.$bvToast.toast('نظرسنجی با موفقیت ایجاد شد', {
                    title: 'موفقیت',
                    toaster: 'b-toaster-top-right',
                    variant: 'success',
                  })
                  this.vote = { is_active: true }
                } else {
                  this.$bvToast.toast(data.message ?? 'در ایجاد نظرسنجی خطایی رخ داده', {
                    title: 'حطا',
                    toaster: 'b-toaster-top-right',
                    variant: 'danger',
                  })
                }
              })
              .catch(error => {
                this.$bvToast.toast(error.response.data.message ?? error.message, {
                  title: 'خطا در دریافت اطلاعات',
                  toaster: 'b-toaster-top-right',
                  variant: 'danger',
                })
              })
          }
        })
    },
    getPermissions() {
      this.$http.get('user/permissions?paginate=false')
        .then(({ data }) => {
          this.permissionList = data.permissions
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
            title: 'خطا در دریافت اطلاعات',
            toaster: 'b-toaster-top-right',
            variant: 'danger',
          })
        })
    },
    getRoles() {
      this.$http.get('user/roles?paginate=false')
        .then(({ data }) => {
          if (data.status) {
            this.rolesList = data.roles
          } else {
            this.$bvToast.toast(data.message ?? 'دریافت لیست نقش ها با خطا مواجه شد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
            title: 'خطا در دریافت اطلاعات',
            toaster: 'b-toaster-top-right',
            variant: 'danger',
          })
        })
    },
  },
  setup() {
    const {
      getValidationState,

    } = formValidation(name)

    return {
      getValidationState,
    }
  },
}
</script>

<style>

</style>
